import {
    ComposeStateType,
    ComposeTopLevelErrorType,
} from "../../reducer.types";

/**
 * Returns an error if the message is left without
 * contact details selected or manually entered
 */
export const validateContactDetails = ({
    contactMethod,
}: {
    contactMethod: ComposeStateType["contactDetails"]["method"];
}): Pick<ComposeTopLevelErrorType, "noContactDetails"> => {
    return contactMethod === "None"
        ? { noContactDetails: "NO_CONTACT_DETAILS" }
        : {};
};
